import { CreatePackageRequestBody } from "./packageRequestBody";

export const initialNewPackage: CreatePackageRequestBody = {
    description: '',
    packageName: '',
    quantity: 0,
    totalValue: 0,
};